<template>
  <form name="permissions-applications-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col sm="8" lg="6">
          <BTextField
            v-model="form.code"
            validate="required"
            label="Код"
            :disabled="isView"
            :skeleton="skeleton"
            name="code"
            autofocus
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col sm="8" lg="6">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'


const createDefaultData = () => ({
  // id
  code: '',
  // created_at
  name: '',
  // updated_at
})

export default {
  name: 'PermissionsApplicationsForm',
  components: {
    BLayoutExpansion,
    BTextField,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
}
</script>
